import React, { useState, useEffect, useRef } from "react";
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss';
import { Modal } from "react-bootstrap"
import { createPortal } from 'react-dom';
import { Link } from "@StarberryUtils";
import ReactPlayer from 'react-player'
import { useLocation } from "@reach/router"
import {
    isIOS,
    isMobileOnly,
    isBrowser,
    isMobile
} from "react-device-detect";
import $ from "jquery"

const ModalWindow = ({ children }) => {
    // element to which the modal will be rendered
    const el = document.createElement("div");
    // add a class to the container div for styling
    // el.className = "modal-portal-container";
    useEffect(() => {
        const modalRoot = document.body;
        // append to root when the children of Modal are mounted
        modalRoot.appendChild(el);
        // do a cleanup
        return () => {
            modalRoot.removeChild(el);
        };
    }, [el]);

    return(
        createPortal(
            children,
            el
        )
    )
}


const PropertyDetailsModal = (props) => {
    const [isOpen, setOpen] = useState(false);
    const [videotype, setVideoType] = useState('youtube');
    const [youtubeid, setYoutubeID] = useState('youtube');

    const [video_url, setVideoURL] = useState('');

     const trackerVideo = (event) => {    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Video Play Btn',
          'formType': event,
          'formId': 'Video Play',
          'formName': 'Video',
          'formLabel': 'Video'
        });
    }

    
    function checkvideo(url) {
    let url_one = String(url)
    let youtube = url_one.indexOf("youtube.com") > -1
    let matter = url_one.indexOf("matterport.com") > -1
    let matter_model = url_one.indexOf("models") > -1
    let isInstagram = url_one.indexOf("instagram") > -1;
    if(youtube == true) {
        setVideoType("youtube")
        setYoutubeID(url_one.split( '/' ).pop())
    } else if (url_one.includes("instagram.com")) {
        const match = url_one.match(/instagram\.com\/reels?\/([^/?]+)/);
        setVideoType("instagram");
        if (match && match[1]) {
            const reelId = match[1];
            setVideoURL(`https://www.instagram.com/reel/${reelId}/embed/?cr=1&v=14&wp=400`);
        } else {
            setVideoURL(props.url);
        }
        
    }
    else if(matter == true) {
        setVideoType("matterport")
        if(matter_model){
            if(url_one.split( '/' ).pop()) {
                setVideoURL("https://my.matterport.com/show/?m="+url_one.split( '/' ).pop())
            }
        }
        else {
            setVideoURL(props.url)
        }
    }
    
    }
    console.log("page1", video_url)
    const normalizeYouTubeUrl = (url) => {
    try {
        const { hostname, pathname } = new URL(url)
        // Only handle YouTube Shorts URLs
        if (!hostname.includes('youtube.com') || !pathname.startsWith('/shorts/')) {
        return url
        }
        const videoId = pathname.split('/shorts/')[1]?.split('/')[0]      
        return videoId
        ? `https://www.youtube.com/watch?v=${videoId}`
        : url
    } catch {
        return url
    }
    }

    const [isPlay, setPlay] = useState(false);
    const vidRef = useRef(null);
    const [show, setShow] = useState(false);
    const [play, setPlayvideo] = useState(true);
    const [mute, setMute] = useState(true);
    const [controls, setVideoControls] = useState(false);

    
    
    const [showHTMLVideo, setHTMLVideo] = React.useState(false);
    const [videoError, setVideoError] = React.useState(false);
    const pausevideo = (ref) => {
      setPlayvideo(false)
      setVideoControls(false)
    
    }
    const playvideo = (ref) => {
      setPlayvideo(true)
      setVideoControls(false)
      setTimeout(function(){ $(".modal-bg-black").hide() }, 1700);
    }
    const showControls = () => {
      setVideoControls(true)
    }
    
    return(
        <>
            {props.icon ? 
                <Link to="#" className="d-md-none" onClick={() => { setHTMLVideo(true); setVideoError(false); playvideo(); setShow(true);checkvideo(props.url);setOpen(true); }}><i class="icon-play-blue"></i></Link> 
                : 
                <a href="javascript:void(0)" onClick={() => { setHTMLVideo(true); setVideoError(false); playvideo(); setShow(true);checkvideo(props.url);setOpen(true); }}>
                    <strong className="play-btn">
                        <i className="icon-play-icon"></i>
                    </strong>
                </a>
            }


            {isOpen && showHTMLVideo && videotype == 'matterport' ?
                <ModalWindow>
                    <div className="matterPort-popup">
                        <ModalVideo channel='custom' isOpen={isOpen} url={`${video_url}&play=1`} onClose={() => setOpen(false)} />
                    </div>
                </ModalWindow> : isOpen && showHTMLVideo && videotype != 'matterport' ?
                <Modal
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="modal-video"
                aria-labelledby="example-custom-modal-styling-title"
                backdropClassName="video-backdrop"
                className="area-guide-full-video-popup"
                >
                <Modal.Header closeButton>
                </Modal.Header>
                    <Modal.Body>


                    {isMobile &&
                    <div className="modal-bg-black">
                    </div>
                    }
                    {videotype=="instagram" ?
                    <div className="instaFrame-fullscreen">
                        <div className="instaFrame-wrapper">
                            <iframe
                                src={video_url}
                                allowFullScreen
                                title="Instagram Reel"
                                className="instaFrame"
                            />
                        </div>
                    </div>
                    :
                    (videoError ?
                        <div className="video-unavailable">
                            <p>Sorry, this video is currently unavailable.</p>
                        </div>
                        :
                    <ReactPlayer frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen autoplay ref={vidRef} onPlay={trackerVideo(props.title)} url={normalizeYouTubeUrl(props.url)} modestbranding="1"  controls={isMobile && isIOS ?true:false} autoplay={true} muted={isMobile && isIOS ? mute : false} playsinline={true} playing={play} onEnded={() => { setHTMLVideo(false) }} onError={() => setVideoError(true)} width='100%' height='100vh' />
                    )
                    }
                    </Modal.Body>
                </Modal> : ''

            }
        </>
    )
}

export default PropertyDetailsModal

